/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregatedPerDoctor', {
                parent: 'hospitalizationsAggregated',
                url: '/perDoctor',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated Per Doctor'
                },
                templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/perDoctor/hospitalizationsAggregatedPerDoctor.html',
                controller: 'HospitalizationsAggregatedPerDoctorController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
